import _ from "lodash";
import { PaginationReq, BaseClass, UpdaterResp, PaginationResp } from "@/core/interface";

class DictValBaseReq extends BaseClass {
  tenantDictId: number = 0;
  valName: string = "";
  valCode: string = "";
  sort: number = 0;
  description: string = "";
  enable: boolean = false;
}

export class DictValReq extends DictValBaseReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class DictValPageReq extends PaginationReq {
  tenantDictId: string = "";
  valName: string = "";
  enable: boolean|undefined = undefined;
  dictCode: string|undefined = undefined;
  constructor(req = {}) {
    super();
    _.merge(this, req);
  }
}

export class DictValPageRecord extends UpdaterResp {
  tenantDictId: number = 0;
  id: number = 0;
  valName: string = "";
  valCode: string = "";
  sort: number = 0;
  description: string = "";
  enable: boolean = false;
}

export class DictValPageResp extends PaginationResp<DictValPageRecord> {
  id: string = "";
}

export class DictValListReq {
  dictCode: string = "";
  enable: boolean = false;
}

export class DictValListResp {
  records: DictValPageRecord[];
}

export class DictValDetailResp extends UpdaterResp {
  tenantDictId: number = 0;
  id: number = 0;
  valName: string = "";
  valCode: string = "";
  sort: number = 0;
  description: string = "";
  enable: boolean = false;
}
